var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ab wh b-l",class:[{
	siteCovered   : _vm.getSiteCovered,
	light         : _vm.getLight,
	vertical      : !_vm.getHorizontalScrolling ,
	horizontal    : _vm.getHorizontalScrolling,
	scrolled      : _vm.pageIsScrolled
}, _vm.pageName],style:(_vm.style),attrs:{"id":"hoborg"}},[_c('main-nav'),_c('side-nav'),_c('scroll-bar'),_c('main-menu'),_c('pop-up'),_c('cursor-follow'),_c('main',{ref:"main",class:{ pe: _vm.getPageIsGrabbing },attrs:{"id":"main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }